import React, {PropTypes} from 'react';
import {
  Avatar
} from 'material-ui';
import Chip from 'material-ui/Chip';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/user-task';
const defaultAvatar = require('../assets/images/default-avatar.png'); // Tell webpack to load image

class HiddenUsers extends React.Component {
  constructor(props) {
    super(props);
    this.handleRequestDelete = this.handleRequestDelete.bind(this);
  }

  handleRequestDelete(user) {
    this.props.actions.removeHiddenUidIfNeeded(user.uid);
  }

  render() {
    const {users} = this.props;
    const styles = {
      chip: {
        margin: 4
      },
      wrapper: {
        display: 'flex',
        flexWrap: 'wrap'
      }
    };

    return (
      <div style={styles.wrapper}>
        {users.map((u) => {
          let avatarUrl = defaultAvatar;
          if (u.avatarUrl) {
            avatarUrl = u.avatarUrl.replace(/s[0-9]+\-c/, 's40-c');
          }
          return (
            <Chip style={styles.chip} key={u.uid} onRequestDelete={() => this.handleRequestDelete(u)}>
              <Avatar src={avatarUrl} />
              {u.name}
            </Chip>
          )
        })}
      </div>
    )
  }
}

HiddenUsers.propTypes = {
  actions: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HiddenUsers);



/** WEBPACK FOOTER **
 ** ./src/components/HiddenUsers.js
 **/